//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

export const PropertyLengths = {
	ApiKey: { 
        Name: 64,
        Description: 255
    },
	Parent: { 
        Address: 255,
        EmailAddress: 190,
        FirstName: 60,
        HomePhone: 32,
        LastName: 60,
        MobilePhone: 32,
        Title: 15,
        WorkPhone: 32,
        Note: 1000000
    },
	School: { 
        EmailAddress: 255,
        InvoiceNumberFormat: 45,
        Name: 255,
        Partner: 32,
        Phone: 45,
        ReferralCode: 10,
        TimeZone: 45
    },
	Student: { 
        EmailAddress: 190,
        FaceTimeID: 64,
        FirstName: 60,
        Gender: 32,
        Instrument: 255,
        LastName: 60,
        Level: 100,
        LocalSchool: 100,
        MobilePhone: 32,
        Referrer: 255,
        SkypeUsername: 255,
        Note: 1000000
    },
	Teacher: { 
        Address: 255,
        EmailAddress: 190,
        FirstName: 255,
        LastName: 255,
        Phone: 255,
        Title: 15,
        ZoomMeetingURL: 255,
        Instrument: 255,
        BiographyBody: 1000,
        Note: 1000000
    },
	BankAccount: { 
        AccountholderName: 255,
        BankName: 64
    },
	Webhook: { 
        Url: 255,
        Description: 255
    }
};
